module.exports = __webpack_public_path__ + "static/media/category17.ddebf4a5.jpg";